import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-coordinator',
    templateUrl: './coordinator.component.html',
    styleUrls: ['./coordinator.component.scss'],
    standalone: false
})
export class CoordinatorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
 